module.exports = __webpack_public_path__ + "img/dummy.da7c328d.png";